import { render, staticRenderFns } from "./EmptyPlug.vue?vue&type=template&id=74d0563b"
import script from "./EmptyPlug.vue?vue&type=script&lang=ts"
export * from "./EmptyPlug.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports